<template>
  <div class="container-wrapper">
    <div class="breadcrumb-wrapper">
      <span>会员卡售卖 / {{ id ? "编辑" : "新增" }}</span>
      <el-button class="back" type="primary" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>

    <div class="form-wrapper">
      <el-form
        label-width="96px"
        label-position="left"
        :model="formData"
        :rules="formRules"
        ref="formRef"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            placeholder="请输入名称"
            v-model="formData.name"
            :maxlength="nameMaxLength"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            placeholder="请选择类型"
            v-model="formData.type"
            :disabled="isEdit"
            @change="handleTypeChange"
          >
            <el-option label="售卖卡" :value="1"></el-option>
            <el-option label="赠送卡" :value="2"></el-option>
            <el-option label="预售卡" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="特权角色" prop="privilegeRoleId">
          <el-select
            placeholder="请选择特权角色"
            filterable
            v-model="formData.privilegeRoleId"
            :disabled="isEdit"
          >
            <el-option
              v-for="(item, index) in privilegeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 预售卡：会员时长改为选择时间范围（生效 00:00:00 / 结束 23:59:59） -->
        <el-form-item v-if="isPreSale" label="会员时长" prop="timeRange">
          <el-date-picker
            v-model="formData.timeRange"
            type="daterange"
            range-separator="至"
            placeholder="选择日期范围"
            format="yyyy-MM-dd"
            :disabled="isEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-else label="会员时长" prop="duration">
          <el-input-number
            :controls="false"
            v-model="formData.duration"
            :min="1"
            :disabled="isEdit"
          ></el-input-number>
          <span>天</span>
        </el-form-item>
        <!-- <el-form-item label="自动续费" prop="duration">
          <div>
            <el-radio-group v-model="formData.isAutoRenew">
              <el-radio :label="0" :value="0">否</el-radio>
              <el-radio :label="1" :value="1">是</el-radio>
            </el-radio-group>
          </div>
          <div
            v-if="formData.isAutoRenew"
            style="color: #999; margin-left: 60px; line-height: 20px"
          >
            <div>1、会员到期前自动续费;</div>
            <div>2、若设置赠送体验卡，在自动续费成功后，体验卡将重复赠送</div>
          </div>
        </el-form-item> -->
        <el-form-item label="售卖价格" prop="price">
          <el-input-number
            :controls="false"
            v-model="formData.price"
            :min="0.01"
            :disabled="isEdit"
          ></el-input-number>
          <span style="margin-left: 12px"
            >有促销价时,售卖价将作为划线价展示</span
          >
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number :min="0" v-model="formData.sort"></el-input-number>
          <div>越小越靠前，如一直则新创建的靠前</div>
        </el-form-item>
        <!-- <el-form-item label="售卖图" prop="url">
          <UploadImage
            keys="url"
            :urls="formData.url"
            @onUrls="onUrls"
            tips="支持jpg、png、gif"
          />
        </el-form-item> -->
        <el-form-item label="赠送体验卡">
          <div class="flex-column">
            <div
              class="flex-row margin-bottom-10"
              v-for="(item, index) in formData.cardConfig"
              :key="index"
            >
              <el-select
                style="flex: 1"
                placeholder="请选择体验卡"
                v-model="item.label"
                :disabled="isEdit"
              >
                <el-option
                  v-for="(card, num) in experienceOptions"
                  :key="num"
                  :label="card.label"
                  :value="card.value"
                >
                </el-option>
              </el-select>
              <el-input-number
                style="width: 100px; margin-left: 10px"
                :controls="false"
                :min="1"
                v-model="item.value"
                :disabled="isEdit"
              >
              </el-input-number>
              <span class="margin-left-10">张</span>
              <el-button
                class="margin-left-10"
                type="danger"
                icon="delete"
                :disabled="isEdit"
                @click="clickDeleteCard(index)"
              ></el-button>
            </div>
          </div>
          <el-button
            type="primary"
            icon="plus"
            :disabled="isEdit"
            @click="clickAddCard"
            >添加类型</el-button
          >
        </el-form-item>
        <el-form-item v-if="id" label="已售">
          <div>{{ formData.usedQuantity }}</div>
        </el-form-item>
      </el-form>
    </div>

    <div class="margin-20">
      <el-button type="primary" @click="clickSave()">保存</el-button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";

export default {
  components: {
    UploadImage,
  },

  data() {
    return {
      loading: false,
      // ===== 售卖卡表单（原逻辑） =====
      formData: {
        name: "",
        type: "",
        privilegeRoleId: "",
        duration: 1,
        // 预售卡（type=3）的会员时长改为时间范围，提交时拆成 effectiveStartTime/effectiveEndTime
        timeRange: [],
        price: 0.01,
        sort: 0,
        url: "",
        usedQuantity: 0,
        cardConfig: [],
        status: 2,
        isAutoRenew: 0,
      },
      baseRules: {
        name: { required: true, message: "请输入名称", trigger: "blur" },
        type: {
          required: true,
          type: "number",
          message: "请选择类型",
          trigger: "change",
        },
        privilegeRoleId: {
          required: true,
          message: "请选择特权角色",
          trigger: "change",
        },
        duration: {
          type: "number",
          required: true,
          message: "请输入体验时长",
          trigger: "blur",
        },
        price: {
          type: "number",
          required: true,
          message: "请输入售卖价格",
          trigger: "blur",
        },
        sort: {
          required: true,
          type: "number",
          message: "请输入排序",
          trigger: "change",
        },
        url: { required: true, message: "请上传售卖图", trigger: "blur" },
      },
      id: "",
      privilegeOptions: [],
      experienceOptions: [],
    };
  },

  computed: {
    // 编辑模式：仅「名称」「排序」可修改，其余字段只读
    isEdit() {
      return !!this.id;
    },
    // 预售卡：会员时长改为选择时间范围
    isPreSale() {
      return Number(this.formData.type) === 3;
    },
    // 名称字数上限：售卖卡/预售卡 6 个字，赠送卡 15 个字
    nameMaxLength() {
      return Number(this.formData.type) === 2 ? 15 : 8;
    },
    // 表单校验规则（预售卡不校验会员时长天数，改为选择时间范围）
    formRules() {
      const rules = Object.assign({}, this.baseRules);
      if (this.isPreSale) {
        delete rules.duration;
      }
      return rules;
    },
  },

  created() {
    this.queryPrivilegeRoles();
    this.queryExperienceCard();
  },

  mounted() {
    const queryInfo = this.$route.query;
    if (queryInfo.actionType == "edit") {
      this.handleDetailInfo();
    }
  },

  methods: {
    // ===================== 售卖卡表单（原逻辑保留） =====================
    queryPrivilegeRoles() {
      this.$http({
        url: this.$util.domain + "/adminapi/privilege/v1/queryAll",
        method: "GET",
      })
        .then((res) => {
          const content = res.body.data || [];
          this.privilegeOptions = content.map((item) => ({
            label: item.name,
            value: `${item.id}`,
          }));
        })
        .catch((err) => {
          this.privilegeOptions = [];
        });
    },
    queryExperienceCard() {
      this.$http({
        url: this.$util.domain + "/adminapi/experienceCard/all",
        method: "GET",
      })
        .then((res) => {
          const list = res.data.data || [];
          this.experienceOptions = list.map((item) => ({
            label: item.name,
            value: `${item.id}`,
          }));
        })
        .catch((err) => {
          this.experienceOptions = [];
        });
    },
    handleDetailInfo() {
      const detailInfo = this.$util.getStore("member-sale-list-item");
      this.$util.removeStore("member-sale-list-item");

      const data = JSON.parse(detailInfo);
      this.id = data.id;
      this.formData.name = data.name;
      this.formData.type = data.type || "";
      this.formData.privilegeRoleId = data.privilegeRoleId + "";
      this.formData.duration = data.duration;
      this.formData.price = (data.price || 0) / 100;
      this.formData.sort = data.sort;
      this.formData.url = data.url;
      this.formData.isAutoRenew = data.isAutoRenew;
      this.formData.cardConfig =
        (data.cardConfig || []).map((item) => ({
          label: item.cardId + "",
          value: item.num,
        })) || [];
      this.formData.status = data.status;
      this.formData.usedQuantity = data.usedQuantity;
      // 预售卡：回显时间范围（接口有返回则拆成生效/结束两个日期）
      if (Number(this.formData.type) === 3) {
        const start = this.toDate(data.effectiveStartTime);
        const end = this.toDate(data.effectiveEndTime);
        this.formData.timeRange = start && end ? [start, end] : [];
      }
    },
    // 时间戳 / 字符串 -> Date（兼容 yyyy-MM-dd HH:mm:ss 与 ISO 带 T）
    toDate(val) {
      if (!val) {
        return null;
      }
      if (val instanceof Date) {
        return val;
      }
      if (typeof val === "number") {
        const date = new Date(val);
        return isNaN(date.getTime()) ? null : date;
      }
      const str = String(val);
      let date = new Date(str.replace("T", " ").replace(/-/g, "/"));
      if (isNaN(date.getTime())) {
        date = new Date(str);
      }
      return isNaN(date.getTime()) ? null : date;
    },
    // 预售卡时间格式化：日期 + 写死的时分秒（生效 00:00:00 / 结束 23:59:59）
    formatPreSaleTime(value, timePart) {
      return new Date(
        dayjs(value).format("YYYY-MM-DD") + " " + timePart
      ).getTime();
    },
    sendInfo() {
      let { price, cardConfig, timeRange, ...params } = this.formData;
      params.price = price * 100;
      params.cardConfig = cardConfig.map((item) => ({
        num: item.value,
        cardId: item.label * 1,
        name:
          this.experienceOptions.find((card) => card.value === item.label)
            .label || "",
      }));

      // 预售卡：不提交 duration，改为提交时间范围（开始 00:00:00、结束 23:59:59）
      if (this.isPreSale) {
        delete params.duration;
        const range = timeRange || [];
        if (range.length === 2 && range[0] && range[1]) {
          params.effectiveStartTime = this.formatPreSaleTime(
            range[0],
            "00:00:00"
          );
          params.effectiveEndTime = this.formatPreSaleTime(
            range[1],
            "23:59:59"
          );
        }
      }

      // 编辑走 privilegeConfig/update，且状态保持不变（仅保存，需在列表点「发布」才会变为已发布）
      const isEdit = !!this.id;
      if (isEdit) {
        params["id"] = this.id;
        params.status = this.formData.status;
      }
      this.loading = true;
      this.$http({
        url:
          this.$util.domain +
          (isEdit
            ? "/adminapi/privilegeConfig/update"
            : "/adminapi/privilegeConfig/add"),
        method: "POST",
        dataType: "json",
        body: params,
      })
        .then((res) => {
          if (res.body.error === 10000) {
            this.$router.go(-1);
          } else {
            this.$util.errorMsg(res.body.message);
          }
        })
        .catch((err) => {
          this.$util.errorMsg(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUrls(urls, keys) {
      this.formData[keys] = urls;
    },
    clickAddCard() {
      if (this.formData.cardConfig >= 100) {
        return;
      }
      this.formData.cardConfig.push({ label: "", value: 0 });
    },
    clickDeleteCard(index) {
      if (this.formData.cardConfig.length <= index) {
        return;
      }
      this.formData.cardConfig.splice(index, 1);
    },
    handleTypeChange() {
      // 切换类型后按新上限截断名称（售卖卡/预售卡 6 个字，赠送卡 15 个字）
      const max = this.nameMaxLength;
      if (this.formData.name && this.formData.name.length > max) {
        this.formData.name = this.formData.name.slice(0, max);
      }
    },
    clickSave() {
      const name = this.formData.name || "";
      if (name.length > this.nameMaxLength) {
        this.$util.errorMsg(`名称最多${this.nameMaxLength}个字`);
        return;
      }
      if (this.isPreSale) {
        const range = this.formData.timeRange || [];
        if (range.length !== 2 || !range[0] || !range[1]) {
          this.$util.errorMsg("请选择会员时长");
          return;
        }
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.sendInfo();
        }
      });
    },
  },
};
</script>

<style scoped>
.breadcrumb-wrapper {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// MemberSaleDetail.vue?ddbd82c4